import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../styles/GlobalStyles.css";

const inputStyle = {
  width: "100%",
  padding: "13px 16px",
  border: "1.5px solid var(--blush)",
  borderRadius: "var(--radius)",
  fontFamily: "var(--font-sans)",
  fontSize: "0.95rem",
  color: "var(--dark)",
  background: "#fff",
  outline: "none",
  transition: "border-color 0.2s",
  boxSizing: "border-box"
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [status, setStatus] = useState(null); // "ok" | "err" | null

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_1n0cy1s",
        "template_u2eabe4",
        formData,
        "MJpk6dVWkxqgwxPEE"
      )
      .then(() => {
        setStatus("ok");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch(() => setStatus("err"));
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        maxWidth: "540px"
      }}
    >
      <h3 style={{ marginBottom: "4px" }}>Send a Message</h3>

      <input
        style={inputStyle}
        placeholder="Your name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
        onFocus={(e) => (e.target.style.borderColor = "var(--sage)")}
        onBlur={(e) => (e.target.style.borderColor = "var(--blush)")}
      />
      <input
        style={inputStyle}
        placeholder="Your email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
        onFocus={(e) => (e.target.style.borderColor = "var(--sage)")}
        onBlur={(e) => (e.target.style.borderColor = "var(--blush)")}
      />
      <textarea
        style={{ ...inputStyle, resize: "vertical", minHeight: "120px" }}
        placeholder="Your message"
        name="message"
        value={formData.message}
        onChange={handleChange}
        required
        onFocus={(e) => (e.target.style.borderColor = "var(--sage)")}
        onBlur={(e) => (e.target.style.borderColor = "var(--blush)")}
      />

      <button
        type="submit"
        className="btn btn-primary"
        style={{ alignSelf: "flex-start" }}
      >
        Send Message
      </button>

      {status === "ok" && (
        <p style={{ color: "var(--sage-dark)", fontSize: "0.9rem" }}>
          âœ“ Message sent! I'll be in touch soon.
        </p>
      )}
      {status === "err" && (
        <p style={{ color: "var(--mocha)", fontSize: "0.9rem" }}>
          Something went wrong â€” please email me directly at
          afterglobeautyco@gmail.com
        </p>
      )}
    </form>
  );
};

export default ContactForm;
